// create new array for countries and appending a new object that represents default value
/* eslint-disable */

const countries = [
    {
        name: 'Select a Country',
        id: '',
        regionCode: '',
        code: ''
    },
    ...window.beaches_app.page.countries
];

const callingCodesObj = require('~/js/modules/countryCallingCodes');

// create new array for states and appending a new object that represents default value
const states = [...window.beaches_app.page.states];

// react form elements contact
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import CustomTextarea from '~/js/components/form-controls/CustomTextarea';
import DatesSelector from '~/js/components/groups/DatesSelector';

ReactDOM.render(
    <CustomTextarea
        wrapperClass="groups-message"
        name="description"
        id="description"
        maxLength="1000"
        displayCharacterCount
    />,
    document.getElementById('message-textarea')
);

ReactDOM.render(
    <CountryStateSelector
        countries={countries}
        states={states}
        countryName="country"
        stateName="state"
        stateLabelWrapper="lg-4"
        stateInputWrapper="lg-8"
        countryLabelWrapper="lg-4"
        countryInputWrapper="lg-8"
    />,
    document.getElementById('country-state-selector')
);

ReactDOM.render(
    <DatesSelector fromName="arrival" toName="departure" />,
    document.getElementById('estimated-date')
);

ReactDOM.render(
    <CustomRecaptcha wrapperClassName="xs-12" />,
    document.getElementById('google-recaptcha')
);

const $subscribeLabel = $('.form-label[for="subscribe"]');

$subscribeLabel.text($subscribeLabel.data('normal'));

const $countrySelector = $('select[name="country"]');

$countrySelector.on('change', event => {
    const countryId = event.target.value;

    $subscribeLabel.text($subscribeLabel.data('normal'));

    if (countryId === 'CA') {
        $subscribeLabel.html($subscribeLabel.data('canada'));
    }
});

// form validations
import '~/js/modules/fend';

$('.groups-contact-form').fend({
    rules: {
        firstName: 'lettersOnly',
        lastName: 'lettersOnly',
        jobTitle: 'lettersOnly',
        company: 'lettersOnly',
        city: 'lettersOnly',
        address: 'alphanumeric',
        zipCode: 'alphanumeric',
        // departure: {
        //   greaterThan: 'input[name="arrival"]'
        // },
        confirmEmail: {
            equalTo: '#email'
        }
    },
    messages: {
        confirmEmail: 'Email must be the same',
        arrival: 'Arrival date is required.',
        departure: 'Departure date is required.'
    }
});

const landlineInputId = 'landLineNumber';
const mobileInputId = 'mobileNumber';
const $landlineNumber = $('#landLineNumber');
const $mobileNumber = $('#mobileNumber');
const $validPhone = $('#contactNumberValid');
const inputEvaluation = (inputElement, mirrorInputId) => {
    $validPhone.removeAttr('required');
    $(`#${mirrorInputId}`).removeAttr('required');
    $(`#${mirrorInputId}-error`).remove();
    $validPhone.val(inputElement.value);
};

$(`#${landlineInputId}`).on('change', event => {
    const inputElement = event.target;

    if (inputElement.value) {
        inputEvaluation(inputElement, mobileInputId);
        $validPhone.trigger('blur');
    } else {
        if ($(`#${mobileInputId}`).val()) {
            $validPhone.removeAttr('required');
            $validPhone.val($(`#${mobileInputId}`).val());
        } else {
            $validPhone.val('');
        }
        $validPhone.trigger('blur');
    }
});

$(`#${mobileInputId}`).on('change', event => {
    const inputElement = event.target;

    if (inputElement.value) {
        inputEvaluation(inputElement, landlineInputId);
        $validPhone.trigger('blur');
    } else {
        if ($(`#${landlineInputId}`).val()) {
            $validPhone.removeAttr('required');
            $validPhone.val($(`#${landlineInputId}`).val());
        } else {
            $validPhone.val('');
        }
        $validPhone.trigger('blur');
    }
});

$('#other').on('change', () => {
    $('.interest-other-specify')
        .find('input[name="other-specify"]')
        .toggleClass('hidden-validation');
});

$(document).ready(() => {
    if ($landlineNumber.val()) {
        $validPhone.removeAttr('required');
        $validPhone.val($landlineNumber.val());
        $mobileNumber.trigger('blur');
        $validPhone.trigger('blur');
    }

    if ($mobileNumber.val()) {
        $validPhone.removeAttr('required');
        $validPhone.val($mobileNumber.val());
        $landlineNumber.trigger('blur');
        $validPhone.trigger('blur');
    }
    $('[name=country]').on('change', function() {
        const selectedCountry = $(this).val();

        callingCodesObj.countryCodes.map(function(index) {
            if (selectedCountry === index.code) {
                $('span.countryCode').html(index.dial_code);
            }
        });
    });
});
